<template>
  <div :class="'colors ' + type">
    <div class="checkbox-category">
      <div  v-for="color in options" class="equipment-item check-ctn color-item" :class="color.class" :key="color.id">
        <label> {{color.name}}<input type="checkbox"  :name="type + '[]'" :data-label="color.name"  :id="type + '-' + color.id" :value="color.id" :checked="color.selected" ><span class="checkmark"></span></label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "Color",
  props: {
    label: {
      type: String
    },
    type: {
      type: String
    },
    options: {
      type: Array
    }
  }
}
</script>

<style scoped>

</style>